import * as types from './actionTypes';

export function toggleAppSearchPanelAction(isRelatedTransactionGridOpen) {
  return { type: types.TOGGLE_APP_SEARCH_PANEL, isRelatedTransactionGridOpen };
}

export function setRelatedGridLoadedAction(isRelatedTransactionGridLoaded) {
  return { type: types.SET_RELATED_GRID_LOADED, isRelatedTransactionGridLoaded };
}

export function setDataSearchTrasactionGridProp(dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage) {
  return {
    type: types.SET_DATA_SEARCH_TRANSACTION_GRID_PROP,
    dataTransactionGridStatus,
    dataSearchPrevPage,
    dataSearchNextPage,
  };
}
